export const camelToSentenceCase = str => {
  if (!str) return str;
  // Add spaces before uppercase letters, then trim any spaces at the beginning
  let result = str.replace(/([A-Z])/g, ' $1').trim();

  // Convert the first character to uppercase and the rest to lowercase
  return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
};
